import {
  IBellNotificationPayload,
  SocketMessageTypeEnum,
} from 'shared/models/Socket'

export const getNotificationUrl = (
  notificationType: SocketMessageTypeEnum,
  payload: IBellNotificationPayload
) => {
  switch (notificationType) {
    case SocketMessageTypeEnum.BellNoticeCommentChanged:
      return '/kommunikasjon/oppslag/detaljer/' + payload.ItemId
    case SocketMessageTypeEnum.BellSuggestedSection:
      return '/styrearbeid/generalforsamling/innmeldte-saker/'
    case SocketMessageTypeEnum.BellSectionComment:
      return '/styrearbeid/generalforsamling/'
    case SocketMessageTypeEnum.BellBookingCreated:
      return '/boligselskapet/booking/godkjenninger/'
    case SocketMessageTypeEnum.BellBookingCancelledByUser:
      return '/boligselskapet/booking/ressurser/' + payload.ItemId
    case SocketMessageTypeEnum.BellInsuranceCaseDraftAccepted:
      return '/boligselskapet/forsikring/'
    case SocketMessageTypeEnum.BellInsuranceCaseDraftRejected:
      return '/boligselskapet/forsikring/'
    case SocketMessageTypeEnum.BellBoardMeetingNewComment:
      return '/styrearbeid/moter/mote/' + payload.ItemId
    case SocketMessageTypeEnum.BellNewUnitOwnersReadyForApproval:
      return '/styrearbeid/oppgaver/nyeeiere/' + payload.ItemId
    case SocketMessageTypeEnum.BellLoanImportNewInterestRate:
      return '/okonomi/laan/' + payload.ItemId
    case SocketMessageTypeEnum.BellNewSubleaseApplication:
      return '/styrearbeid/oppgaver/bruksoverlating'
    case SocketMessageTypeEnum.BellSubleaseApproachingEndDate:
      return '/boligselskapet/vaartselskap/enheter/' + payload.ItemId
    case SocketMessageTypeEnum.BellNewPublicationPublishedPortal:
      return '/boligbyggelaget/nyheter/' + payload.ItemId
    case SocketMessageTypeEnum.BellNewSubleaseRegistered:
      return '/boligselskapet/vaartselskap/enheter/' + payload.ItemId
    case SocketMessageTypeEnum.BellNotificationMeetingCreated:
    case SocketMessageTypeEnum.BellNotificationMeetingCancelled:
    case SocketMessageTypeEnum.BellNotificationMeetingChanged:
    case SocketMessageTypeEnum.BellNotificationMeetingAccepted:
    case SocketMessageTypeEnum.BellNotificationMeetingComment:
    case SocketMessageTypeEnum.BellNotificationMeetingDeclined:
    case SocketMessageTypeEnum.BellNotificationMeetingAttendeeChanged:
      return '/boligbyggelaget/avtal-mote/' + payload.ItemId + '/detaljer'
    case SocketMessageTypeEnum.BellReimbursementCreated:
      return '/okonomi/utlegg/' + payload.ItemId
	case SocketMessageTypeEnum.BellNotificationBudgetPublishedPortal:
	case SocketMessageTypeEnum.BellNotificationBudgetReadyForApproval:
	case SocketMessageTypeEnum.BellNotificationBudgetApprovalDeadlineApproaching:
	case SocketMessageTypeEnum.BellNotificationBudgetNewComment:
	  return '/okonomi/budsjett/'
    default:
      return ''
  }
}

export const notificationDescriptions: Partial<
  Record<SocketMessageTypeEnum, string>
> = {
  [SocketMessageTypeEnum.BellNoticeCommentChanged]:
    '- Det er nye kommentarer på oppslaget',
  [SocketMessageTypeEnum.BellSuggestedSection]:
    '- Det er meldt inn en ny sak som ønskes behandlet',
  [SocketMessageTypeEnum.BellSectionComment]: '- Ny kommentar på møte',
  [SocketMessageTypeEnum.BellBookingCreated]: '- Ny forespørsel om reservasjon',
  [SocketMessageTypeEnum.BellBookingCancelledByUser]:
    '- Reservasjon kansellert',
  [SocketMessageTypeEnum.BellInsuranceCaseDraftAccepted]:
    '- Skademelding godkjent',
  [SocketMessageTypeEnum.BellInsuranceCaseDraftRejected]:
    '- Skademelding avvist',
  [SocketMessageTypeEnum.BellLoanImportNewInterestRate]: '- Ny renteendring',
  [SocketMessageTypeEnum.BellSubleaseApproachingEndDate]:
    '- Påminnelse om leieforhold som opphører',
  [SocketMessageTypeEnum.BellReimbursementCreated]:
    '- Nytt utlegg klart for behandling',
}
